__turbopack_context__.v({
  "alertsTitle": "alerts-module-scss-module__WLjYlG__alertsTitle",
  "container": "alerts-module-scss-module__WLjYlG__container",
  "sectionTitle": "alerts-module-scss-module__WLjYlG__sectionTitle",
  "timezone": "alerts-module-scss-module__WLjYlG__timezone",
  "title": "alerts-module-scss-module__WLjYlG__title",
});
